var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-img-viewer"},[_c('div',{staticClass:"pdf-img-viewer__toolbar"},[_c('button',{staticClass:"pdf-img-viewer__open-btn",attrs:{"type":"button","disabled":!_vm.fileUrl},on:{"click":_vm.openInNewPage}},[_vm._v(" 在新页面打开文件 ")])]),_c('iframe',{attrs:{"src":_vm.fileUrl,"width":"100%","height":"800px","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }